import { createAction, props } from '@ngrx/store';
import { SystemConfigValue } from 'src/app/admin/system-configuration/shared/models/system-config-value';

export const receivedProvisionLogData = createAction(
    '[Message Hub] Received ProvisionLogData',
    props<{ messageData: string }>()
);

export const joinDataImportGroupComplete = createAction(
    '[Message Hub] Joining Data Import Group Complete'
)

export const receivedActiveAlertsForUser = createAction(
    '[Message Hub] Received ActiveAlertsForUser',
    props<{ messageData: string }>()
);

export const receivedAppointmentGridData = createAction(
    '[Message Hub] Received AppointmentGrid Data',
    props<{ messageData: string }>()
);
export const receivedMyAppointmentGridData = createAction(
    '[Message Hub] Received My AppointmentGrid Data',
    props<{ messageData: string }>()
);

export const receivedCentralBranchStatusGridData = createAction(
    '[Message Hub] Received CentralBranchStatusGrid Data',
    props<{ messageData: string }>()
);

export const receivedCentralLobbyStatusGridData = createAction(
    '[Message Hub] Received CentralLobbyStatusGrid Data',
    props<{ messageData: string }>()
);

export const receivedCentralStaffStatusGridData = createAction(
    '[Message Hub] Received CentralStaffStatusGrid Data',
    props<{ messageData: string }>()
);

export const receivedLobbyStatusGridData = createAction(
    '[Message Hub] Received LobbyStatusGrid Data',
    props<{ messageData: string }>()
);

export const receivedLobbyStaffStatusGridData = createAction(
    '[Message Hub] Received LobbyStaffStatusGrid Data',
    props<{ messageData: string }>()
);

export const receivedSignedInUsersAndGroupsData = createAction(
    '[Message Hub] Received SignedInUsersAndGroups Data',
    props<{ messageData: string }>()
);

export const receivedLobbyLocationSelectorStatus = createAction(
    '[Message Hub] Received LobbyLocationSelector Status',
    props<{ messageData: string }>()
);

export const receivedSystemConfigurationData = createAction(
    '[Message Hub] Received SystemConfiguration Data',
    props<{ payload: { systemConfigurations: SystemConfigValue[] } }>()
);

export const receivedSignalRStaffStatusGridData = createAction(
    '[Message Hub] Received SignalRStaffStatusGrid Data',
    props<{ messageData: string }>()
);

export const receivedStatBarData = createAction(
    '[Message Hub] Received StatBar Data',
    props<{ messageData: string }>()
);

export const receivedUserSignedInStatus = createAction(
    '[Message Hub] Received UserSignedInStatus',
    props<{ messageData: string }>()
);

export const receivedLobbyEntryWaitCountByLocation = createAction(
    '[Message Hub] Received LobbyEntry Wait Count By Location',
    props<{ messageData: string }>()
);

export const receivedAppointmentWaitCountByLocation = createAction(
    '[Message Hub] Received Appointment Wait Count By Location',
    props<{ messageData: string }>()
);

export const receivedSyncStatus = createAction(
    '[Message Hub] Received Sync Status',
    props<{ messageData: string }>()
)

export const joinLobbySignInUsersGroupActionComplete = createAction(
    '[Message Hub] Join Lobby SignIn Users Group ActionComplete',
);

export const joinCentralStaffStatusGroupActionComplete = createAction(
    '[Message Hub] Join Central Staff Status Group ActionComplete',
);

export const joinCentralLocationGroupActionComplete = createAction(
    '[Message Hub] Join Central Location Group ActionComplete',
);

export const joinCentralLobbyGroupActionComplete = createAction(
    '[Message Hub] Join Central Lobby Group ActionComplete',
);

export const joinAppointmentStatusGridActionComplete = createAction(
    '[Message Hub] Join Appointment Status Grid Action Complete',
);

export const joinLobbyStatusBarActionComplete = createAction(
    '[Message Hub] Join Lobby Status Bar Action Complete',
);

export const joinLobbyStaffStatusGridActionComplete = createAction(
    '[Message Hub] Join Lobby Staff Status Action Complete',
);

export const joinLobbyEntryWaitCountByLocationActionComplete = createAction(
    '[Message Hub] Join Lobby Entry Wait Count By Location Action Complete',
);

export const joinAppointmentWaitCountByLocationActionComplete = createAction(
    '[Message Hub] Join Appointment Wait Count By Location Action Complete',
);

export const joinAppointmentStatusByLocationActionComplete = createAction(
    '[Message Hub] Join Appointment Status By Location Action Complete',
);

export const joinStaffAppointmentActionComplete = createAction(
    '[Message Hub] Join Staff Appointment Action Complete',
);

export const messageHubConnectionStarted = createAction(
    '[Message Hub] Message Hub Connection Started',
);
export const messageHubConnectionReStarted = createAction(
    '[Message Hub] Message Hub Connection ReStarted',
);

export function routeToAppointmentWidgetComplete(): any {
    throw new Error('Function not implemented.');
}

export const receivedClientCreateStatus = createAction(
    '[Message Hub] Received Client Create Status',
    props<{ messageData: string }>()
);

export const receivedAppointmentStatusByLocationData = createAction(
    '[Message Hub] Received Appointment Status By Location Data',
    props<{ messageData: string }>()
);

export const receivedStaffAppointmentData = createAction(
    '[Message Hub] Received Staff Appointment Data',
    props<{ messageData: string }>()
);